<template>
  <el-container v-loading="isShowLoading">
    <div></div>
    <el-main>
      <!-- <el-row>
        <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
          <el-tooltip
            class="item"
            effect="dark"
            content="返回上一级页面"
            placement="bottom-start"
            :disabled="showTooltip"
          >
            <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
          </el-tooltip>
        </el-col>
        <el-col :span="12">
          <h3>
            <span>添加开票点收费项目明细</span>
          </h3>
        </el-col>
      </el-row>-->
      <el-row>
        <el-form :model="filterData" :inline="true">
          <el-form-item>
            <el-input v-model="filterData.auxItemCode" placeholder="请输入收费项目明细编码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filterData.auxItemName" placeholder="请输入收费项目明细名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="onAdd"
            v-bind:disabled="enableBtn.bc"
          >保存</el-button>
        </el-col>
      </el-row>

      <el-table
        ref="singleTable"
        :data="recordData"
        highlight-current-row
        style="width: 100%"
        :row-style="{height:'30px'}"
        :cell-style="{padding:'2px'}"
        :header-cell-style="{background:'#f5f7fa', color: 'black'}"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" label="选择" width="50"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column property="auxItemName" label="收费项目明细名称" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemCode" label="收费项目明细编码" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemUnit" label="收费项目明细单位" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemStd" label="收费项目明细标注" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="auxItemRemark" label="收费项目明细备注" width="140" show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <el-row style="margin: 18px 8px">
        <el-col :span="24">
          <pagination
            v-show="pagination.total/pagination.pageSize>1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageSize"
            @pagination="onFilter"
          />
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer" style="height: 60px">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
let _kits, _table;
export default {
  props: ["entity"],
  components: {},
  data() {
    return {
      isShowLoading: true,
      dialogFormVisible: false,
      pageWidth: 600,
      showTooltip: false,
      //页面布局相关
      layout: {
        loading: true,
        width: 600,
        wd: "80%",
        edit: false
      },
      //数据绑定相关
      filterData: {
        agencyCode: this.entity.agencyCode,
        placeCode: this.entity.placeCode,
        itemCode: this.entity.itemCode,
        auxItemCode: "",
        auxItemName: ""
      }, //过滤信息
      recordData: [], //展示信息
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      }, //分页信息
      entityData: {}, //具体某一项信息
      multipleSelection: [],
      enableBtn: {
        //控制启用禁用
        bc: true,
        tb: true,
        xz: true,
        xg: true
      }
    };
  },
  methods: {
    onAdd() {
      if (this.multipleSelection.length < 1) {
        this.$message.error("没有选择要添加的收费项目明细");
        return;
      }
      _kits.api.call(
        "SAVEAGENCYPLACEITEMAUX",
        {
          list: this.multipleSelection,
          agencyCode: this.filterData.agencyCode,
          placeCode: this.filterData.placeCode,
          itemCode: this.filterData.itemCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.$message.success(result.returnMsg);
            this.$emit("back");
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    },
    onFilter() {
      this.layout.loading = true;
      _table.load();
    },
    init() {
      _table.load();
    },
    onBack() {
      this.$emit("back");
    },
    handleSelectionChange(val) {
      this.multipleSelection = this.null2str(val);
      console.log("this.multipleSelection.length",this.multipleSelection);
      if (this.multipleSelection.length > 0) {
        this.enableBtn.bc = false;
      } else {
        this.enableBtn.bc = true;
      }
    },
     null2str(data) {
                if (typeof data != 'object'|| data === null|| data ==='null') {
                    data = '';
                    return data;
                }else{
                    for (let x in data) {
                        if (data[x] === null || data[x] === 'null') { // 如果是null 把直接内容转为 ''
                            data[x] = '';
                        } else {
                            if (Array.isArray(data[x])) { // 是数组遍历数组 递归继续处理
                                data[x] = data[x].map(z => {
                                    console.log(z)
                                    return this.null2str(z);
                                });
                            }
                            if(typeof(data[x]) === 'object'){ // 是json 递归继续处理
                                data[x] = this.null2str(data[x])
                            }
                        }
                    }
                    return data;
                }
            },   
  },
  created() {
    this.pageWidth = window.innerWidth - 200;
    _kits = this.$kits();
    _table = _kits.table(
      "QUERYAGENCYITEMAUXMINUSLIST",
      () => {
        return Object.assign({}, this.filterData, this.pagination);
      },
      result => {
        this.isShowLoading = false;
        this.recordData = result.list;
        this.pagination.total = Number.parseInt(result.total);
      }
    );
    this.init();
  },
  mounted() {
    setTimeout(() => {
      _kits.page.foucus("ipt01");
      this.showLoading = false;
      this.showTooltip = true;
    }, 300);
  }
};
</script>
<style scoped>
</style>
